module.exports = "<iframe width=\"100%\" height=\"100%\" frameborder=\"0\" [src]=\"urlTarget | safe\"></iframe>"